import React from "react";
import { Users2, Folder, Archive as ArchiveIcon, FileText } from "lucide-react";

/**
 * Compact tier snapshot shown below the Package dropdown when onboarding
 * or editing an ID firm — gives the super admin an instant read of what
 * they're picking without leaving the dialog.
 *
 * The tier prop matches the response of GET /superadmin/subscription-tiers.
 */
export default function TierPreview({ tier }) {
  if (!tier) return null;
  const limits = tier.limits || {};
  const rows = [
    { icon: <Users2 size={12} />, label: "Team users", value: limits.max_team_users },
    { icon: <Folder size={12} />, label: "Concurrent projects", value: limits.max_concurrent_projects },
    { icon: <ArchiveIcon size={12} />, label: "Archived projects", value: limits.max_archived_projects },
    { icon: <FileText size={12} />, label: "Documents / project", value: limits.max_documents_per_project },
  ];
  return (
    <div
      data-testid="tier-preview"
      className="mt-2 rounded-2xl border border-[#EBE5D9] bg-[#FBF7EF]/70 p-3 space-y-1.5"
    >
      {tier.description && (
        <div className="text-[11px] text-[#7A7571] leading-relaxed pb-1">{tier.description}</div>
      )}
      {rows.map((r) => (
        <div key={r.label} className="flex items-center justify-between text-xs">
          <span className="text-[#7A7571] inline-flex items-center gap-1.5">
            {r.icon} {r.label}
          </span>
          <span className="font-semibold text-[#2C2A29]">
            {r.value == null ? "—" : Number(r.value).toLocaleString()}
          </span>
        </div>
      ))}
    </div>
  );
}
